export default __webpack_public_path__ + "static/media/kili-pack3.a5d93830.jpg";